import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const ArrowRightIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "ArrowRightIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M15.0322 18.9678C15.2257 18.9678 15.4192 18.894 15.5669 18.7463L21.7785 12.5347C22.0738 12.2393 22.0738 11.7608 21.7785 11.4654L15.5669 5.25377C15.2715 4.95838 14.7929 4.95838 14.4975 5.25377C14.2021 5.54916 14.2021 6.0277 14.4975 6.32309L20.1745 12L14.4975 17.677C14.2021 17.9724 14.2021 18.4509 14.4975 18.7463C14.6452 18.894 14.8387 18.9678 15.0322 18.9678Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M2.75621 12.7557H21.2438C21.6613 12.7557 22 12.417 22 11.9995C22 11.5821 21.6613 11.2433 21.2438 11.2433H2.7562C2.33872 11.2433 2 11.5821 2 11.9995C2 12.417 2.33873 12.7557 2.75621 12.7557Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default ArrowRightIcon;
